module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_William_Paloma.7d657121.jpg";